export const normalizeGeneratedEstimateProductId = (value) => {
  if (value === "" || value == null) return null;
  return String(value).trim() || null;
};

export const resolveGeneratedEstimateProductId = (product = {}) =>
  normalizeGeneratedEstimateProductId(
    product?.Id ??
      product?.id ??
      product?.ProductId ??
      product?.productId
  );

export const resolveGeneratedEstimateOrderItemId = (product = {}) =>
  normalizeGeneratedEstimateProductId(
    product?.orderItemId ??
      product?.OrderItemId
  );

export const resolveGeneratedEstimateLineId = (product = {}) =>
  normalizeGeneratedEstimateProductId(product?.lineId);

export const resolveGeneratedEstimateProductIdentityKey = (product = {}) =>
  normalizeGeneratedEstimateProductId(
    resolveGeneratedEstimateLineId(product) ??
      resolveGeneratedEstimateOrderItemId(product) ??
      resolveGeneratedEstimateProductId(product)
  );

export const updateGeneratedEstimateProductComment = (products = [], productId, comment) => {
  const targetId = normalizeGeneratedEstimateProductId(productId);
  if (!targetId) return Array.isArray(products) ? [...products] : [];

  return (Array.isArray(products) ? products : []).map((product) =>
    resolveGeneratedEstimateProductIdentityKey(product) === targetId
      ? { ...product, comment }
      : product
  );
};

export const findGeneratedEstimateProductById = (products = [], productId) => {
  const targetId = normalizeGeneratedEstimateProductId(productId);
  if (!targetId) return null;
  return (Array.isArray(products) ? products : []).find(
    (product) => resolveGeneratedEstimateProductIdentityKey(product) === targetId
  ) || null;
};
